import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createValidateModel } from '@cian/api-models/monolith-csharp/api/users/validate';
export function validate(httpApi, subdomain, parameters) {
  return httpApi.fetch(_objectSpread(_objectSpread({}, createValidateModel({
    parameters: parameters
  })), {}, {
    assertStatusCodes: [200, 400, 429]
  }), {
    subdomain: subdomain,
    bodyAsEncodeString: true,
    requestConfig: {
      headers: [['Content-Type', 'application/x-www-form-urlencoded']]
    }
  });
}
export { ILogOnInfo } from '@cian/api-models/monolith-csharp/api/users/common';